// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {routerActions} from 'react-router-redux';

export const updateAdjustmentValue = (itemNumber, valueOfAdjustment) => ({
    itemNumber,
    type: actions.UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_VALUE,
    valueOfAdjustment
});

export const updateAdjustmentType = (itemNumber, adjustmentType, adjustmentTypes) =>
    dispatch => {

        dispatch({
            adjustmentType,
            adjustmentTypes,
            itemNumber,
            type: actions.UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_TYPE
        });

        if (adjustmentType === '01' || adjustmentType === '') {

            dispatch({
                itemNumber,
                type: actions.UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_VALUE,
                valueOfAdjustment: null
            });

        }

    };

export const completePartialDebit = auditNumber =>
    dispatch => {

        if (auditNumber) {

            dispatch(routerActions.push(`/tcsm/audits/record?auditNumber=${auditNumber}`));

        } else {

            dispatch(routerActions.goBack());

        }

    };

export const updatePartialDebitComments = comments => ({
    comments,
    type: actions.UPDATE_TCSM_PARTIAL_DEBIT_COMMENTS
});

export const resetPartialDebit = () => ({
    type: actions.RESET_TCSM_PARTIAL_DEBIT
});



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/action-creators/debit.js